import { injectSaga } from '@capillarytech/vulcan-react-sdk/utils';
export default injectSaga;